import './styles.scss';

import { Auth } from 'aws-amplify';
import PropTypes from 'prop-types';
import React from 'react';
import {
  Button, Col, Container, Form, Row
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import LoadingButton from '../../components/LoadingButton';
import LoadingControl from '../../components/LoadingControl';
import backend, { ENVIRONMENT } from '../../services/backend';
import { alertError } from '../../store/ducks/alert';

export class Login extends React.Component {
  async componentDidMount() {
    this.env = await backend.get(ENVIRONMENT);
  }

  formRef = React.createRef();

  handleAdfsLogin = () => {
    const redirectUri = window.location.href.replace('/login', '/');

    window.location.assign(`https://${this.env.data.domain}/oauth2/authorize?`
      + `client_id=${this.env.data.clientId}`
      + '&response_type=token'
      + `&redirect_uri=${redirectUri}`
      + '&scope=openid');
  };

  handleManualLogin = async () => {
    const { dispatch } = this.props;

    try {
      const user = await Auth.signIn(
        this.formRef.current.email.value,
        this.formRef.current.password.value
      );

      window.location.assign(window.location.href.replace('/login', `#id_token=${user.signInUserSession.idToken.jwtToken}`));
    } catch (error) {
      dispatch(alertError(error.message || JSON.stringify(error)));
    }
  };

  handleInputsValidation = () => (
    this.formRef.current.reportValidity() !== false
  );

  render() {
    return (
      <Container fluid className="login">
        <Row>
          <Col>
            <div className="pt-5 pl-5 pb-5">
              <h1 className="display-4 mt-4 text-light login__h1">Dyson Single Sign On</h1>
              <Button className="btn btn-primary" onClick={this.handleAdfsLogin}>LOG IN</Button>
            </div>
          </Col>
          <Col xl={1} className="text-center align-self-center">
            <h5 className="login__h5">or</h5>
          </Col>
          <Col>
            <div className="p-5">
              <div>
                <h6 className="mb-2 mt-4 login__h6">Enter your login credentials</h6>
                <Form ref={this.formRef} onSubmit={this.handleManualLogin}>
                  <div className="input-group mb-2">
                    <LoadingControl type="email" name="email" placeHolder="Email address" onValidation={this.handleInputsValidation} onKeyDown={this.handleManualLogin} />
                  </div>
                  <div className="input-group mb-2">
                    <LoadingControl type="password" name="password" placeHolder="Password" onValidation={this.handleInputsValidation} onKeyDown={this.handleManualLogin} />
                  </div>
                  <LoadingButton variant="primary" onValidation={this.handleInputsValidation} onClick={() => this.handleManualLogin()}>LOG IN</LoadingButton>
                  <Link className="ml-2" to="/forgotpassword">First log in or forgot your password?</Link>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect()(Login);
